var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { SPACING_XL, SPACING_M, createUIElement } from "../../helpers";
import { Text, TEXT_VIEW } from "../../Text";
import { STACK_ALIGN, STACK_DIRECTION, STACK_GAP, StackView } from "../../StackView";
import { Icon } from "../../Icon";
export var getTextView = function (disabled, error) {
    var textView;
    if (disabled) {
        textView = TEXT_VIEW.light;
    }
    else if (error) {
        textView = TEXT_VIEW.error;
    }
    else {
        textView = TEXT_VIEW.link;
    }
    return textView;
};
var getHeight = function (compact) {
    return compact ? SPACING_M : SPACING_XL;
};
var WrapperContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"], ["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"])));
var StyledStackView = styled(StackView)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: ", ";\n"], ["\n    height: ", ";\n"])), function (_a) {
    var compact = _a.compact;
    return getHeight(compact);
});
var LinkButtonRoot = styled(Text)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: inline-block;\n    line-height: ", ";\n    cursor: default;\n    text-overflow: ellipsis;\n    outline: none;\n    flex-shrink: 0;\n\n    ", "\n"], ["\n    display: inline-block;\n    line-height: ", ";\n    cursor: default;\n    text-overflow: ellipsis;\n    outline: none;\n    flex-shrink: 0;\n\n    ",
    "\n"])), function (_a) {
    var compact = _a.compact;
    return getHeight(compact);
}, function (_a) {
    var disabled = _a.disabled;
    return !disabled && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            cursor: pointer;\n\n            &:hover,\n            &:focus,\n            &:active {\n                text-decoration: underline;\n            }\n        "], ["\n            cursor: pointer;\n\n            &:hover,\n            &:focus,\n            &:active {\n                text-decoration: underline;\n            }\n        "])));
});
LinkButtonRoot.displayName = 'LinkButtonRoot';
export var LinkButton = createUIElement('LinkButton', function (_a, ref) {
    var className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.error, error = _c === void 0 ? false : _c, children = _a.children, iconBefore = _a.iconBefore, iconAfter = _a.iconAfter, _d = _a.compact, compact = _d === void 0 ? false : _d, onFocus = _a.onFocus, onBlur = _a.onBlur, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "disabled", "error", "children", "iconBefore", "iconAfter", "compact", "onFocus", "onBlur", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var handleClick = function (e) {
        if (!disabled) {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        }
    };
    return (React.createElement(LinkButtonRoot, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'link-button', className: "vm-LinkButton " + className, tabIndex: 0, truncate: true, disabled: disabled, view: getTextView(disabled, error), compact: compact, onFocus: onFocus, onBlur: onBlur, onClick: handleClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        React.createElement(StyledStackView, { align: STACK_ALIGN.center, direction: STACK_DIRECTION.row, gap: STACK_GAP.s, compact: compact },
            iconBefore && (React.createElement(Icon, { "data-selector-id": "icon-before", src: iconBefore, disabled: disabled })),
            children && (React.createElement(WrapperContent, { "data-selector-id": "text-content" }, children)),
            iconAfter && (React.createElement(Icon, { "data-selector-id": "icon-after", src: iconAfter, disabled: disabled })))));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=LinkButton.js.map